import {FC} from 'react';
import {useHistory} from 'react-router-dom';
import {useSession} from './contexts/Session';

const Logout: FC = () => {
  const session = useSession();
  const history = useHistory();

  (async () => {
    await session.logout();
    delete localStorage.intersonToken;
    window.location.href =
      process.env.REACT_APP_COMMON_HOST ??
      'https://espace-pro.interson-protac.com';
  })();
  return null;
};

export default Logout;
